import http from '@/core/http';

const statistic = {
  actions: {
    // 获取首页信息
    GetIndexInfo (ctx, payload) {
      return http.req_get('/admin/action/index', { ...payload });
    },
  },
};

export default statistic;